
export const planetPosition: any = {
  0: [
    {
      position: [0, -0.48, 2.4],
    },

    {
      position: [-0.4, 0.18, 2.4],
    },
    {
      position: [-0.4, -0.3, 2.4],
    },

    {
      position: [0.4, -0.3, 2.4],
    },
    {
      position: [0.42, 0.18, 2.4],
    },

    {
      position: [0, 0.45, 2.4],
    },
  ],
  1: [
    {
      position: [0, -1.5, 1.5],
    },

    {
      position: [-1.5, 0, 1.5],
    },

    {
      position: [1.5, 0, 1.5],
    },

    {
      position: [1.1, -1, 1.5],
    },

    {
      position: [0, 1.5, 1.5],
    },

    {
      position: [1.1, 1, 1.5],
    },
    {
      position: [-1.1, 1, 1.5],
    },
    {
      position: [-1.1, -1, 1.5],
    },
  ],
  2: [
    {
      position: [-1.3, -3.1, 0],
    },
    {
      position: [3.2, 1.2, 0],
    },
    {
      position: [-3.2, 1, 0],
    },
    {
      position: [3.2, -1.2, 0],
    },
    {
      position: [-3.1, -1.3, 0],
    },
    {
      position: [1.5, 3, 0],
    },
    {
      position: [1.2, -3.1, 0],
    },
    {
      position: [-1.5, 3, 0],
    },
  ],
  3: [
    {
      position: [0],
    },
    {
      position: [0],
    },
    {
      position: [0],
    },
    {
      position: [0],
    },
    {
      position: [0],
    },
    {
      position: [0],
    },
    {
      position: [0],
    },
    {
     position: [0],
    },
  ],
  4: [
    {
      position: [-1.3, -3.1, 0],
    },
    {
      position: [3.2, 1.2, 0],
    },
    {
      position: [-3.2, 1, 0],
    },
    {
      position: [3.2, -1.2, 0],
    },
    {
      position: [-3.1, -1.3, 0],
    },
    {
      position: [1.5, 3, 0],
    },
    {
      position: [1.2, -3.1, 0],
    },
    {
      position: [-1.5, 3, 0],
    },
  ],
};
